import { ExportsCardId } from '../enums/exportsCardId'

export interface ExportCardVisibilityConditions {
  isFECReportEnabled: boolean
  isSAFTExportEnabled: boolean
  isProductExportEnabled: boolean
  isReportsReadAuthorized: boolean
  isXAFExportEnabled: boolean
}

type ExportCardVisibilityRule = (conditions: ExportCardVisibilityConditions) => boolean

export const exportCardVisibilityRules: Partial<Record<ExportsCardId, ExportCardVisibilityRule>> = {
  [ExportsCardId.AccountStatement]: ({ isReportsReadAuthorized }) => isReportsReadAuthorized,
  [ExportsCardId.AllData]: ({ isSAFTExportEnabled }) => isSAFTExportEnabled,
  [ExportsCardId.BalanceList]: ({ isReportsReadAuthorized }) => isReportsReadAuthorized,
  [ExportsCardId.ChartOfAccounts]: ({ isReportsReadAuthorized }) => isReportsReadAuthorized,
  [ExportsCardId.EntryJournal]: ({ isReportsReadAuthorized }) => isReportsReadAuthorized,
  [ExportsCardId.FecReport]: ({ isFECReportEnabled }) => isFECReportEnabled,
  [ExportsCardId.Products]: ({ isProductExportEnabled }) => isProductExportEnabled,
  [ExportsCardId.XAF]: ({ isXAFExportEnabled }) => isXAFExportEnabled,
}
